module.exports = __webpack_public_path__ + "media/images/calendar-3e9dfbb203a39c9622868d18cd95e533.svg";